import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import InvoiceType from 'src/models/InvoiceType';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Client from 'src/models/AP/Client';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { FaUserTie } from 'react-icons/fa';
import { VscGraph } from 'react-icons/vsc';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import { ITableConfig } from 'src/components/common/table';
import CPNavBar from '../CPNavBar';
import FindClientDialog from  '../dialogs/FindClientDialog';
import TsdiClient from 'src/models/AP/Client';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import TsdiClientInfo from 'src/models/AP/ClientInfo';
import 'react-datepicker/dist/react-datepicker.css';
import './ClientMaintenancePage.css';
import InvoiceTypeList from 'src/components/project/sections/InvoiceTypeList';
import ClientBillingInfo from 'src/models/ClientBillingInfo';
import { MdHistory } from 'react-icons/md';        // Material Design

const ManageClientBilling = () => {
    const dispatch = useDispatch();
    const [invoiceTypeList, setInvoiceTypeList] = useState<InvoiceType[]>([]);
    const { get, post, put, response } = useFetch();
    const [selectedInvoiceTypes, setSelectedInvoiceTypes] = useState<InvoiceType[]>([]);
    const { reset, register, setValue, getValues, handleSubmit, formState, errors, control } = useForm();
    const { reset: resetSelectedClient, register: registerSelectedClient} = useForm();
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [clientInfo, setClientInfo] = useState<TsdiClientInfo>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [clientTypes, setClientTypes] = useState<{ code: number, description: string}[]>([]);
    const [clientBillingInfo, setClientBillingInfo] = useState<ClientBillingInfo>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const [addingClient, setAddingClient] = useState<boolean>(false);
    const [chargBackupState, setChargeBackupState] = useState<boolean>(false);
    const [billByOptions, setBillByOptions] = React.useState<Array<{ value: number, label: string}>>(undefined);
    const { isDirty } = formState;
    
    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clientInfo) {
            console.log('ClientInfo loaded logic goes here.');
        }
    }, [clientInfo]);

    useEffect(() => {
        if (!!addingClient) {
            showDialog(DialogList.FIND_CLIENT);
        }
    }, [addingClient]);

    useEffect(() => {
        if (!!selectedClient) {
            getClientInfo(selectedClient?.clientNumber);
            if (!!clients && clients?.length > 0) {
                if (selectedClient !== undefined) {
                    resetSelectedClient(selectedClient);
                }
            }
            getClientBillingInfo(selectedClient.clientNumber);
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!clientSearchTerm || clientSearchTerm === '') {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    const getClientInfo = async (clientNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/info/${clientNumber}`);

        if (response.ok) {
            setClientInfo(result);
        } else {
            setClientInfo(new TsdiClientInfo());
            console.log('Unable to get client info data!');
        }
    };

    const getClientBillingInfo = async (clientNumber: number) => {        
        const result = await get(`/v1.0/ClientProjectMaintenance/client/billing/info/${clientNumber}`);

        if (response.ok) {
            console.log('Client Billing Info', result);
            setClientBillingInfo(result);
        }
    };

    const getBillbyOptions = async () => {        
        const result = await get(`/v1.0/ClientProjectMaintenance/billing/billby/options`);

        if (response.ok) {
            if (!!result && result.length > 0) {
                setBillByOptions(result?.map((bbo: { code: number, description: string}) => {
                    return { value: bbo.code, label: bbo.description };
                }));
            }
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const getInvoiceTypes = async () => {
        const result = await get(`/v1.0/clients/${selectedClient}/projects/${1}/invoice/invoice-types`);

        if (response.ok) {
            setInvoiceTypeList(result);
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

/*     const addClient = async (payload: Client) => {
        let result = await post(`/v1.0/AccountsPayable/clients`, payload);

        if (response.ok) {
            console.log('successfully added a client ' + result);
        } else {
            console.log('Unable to get client data!');
        }
    }; */

    const updateClientBillingInfo = async (data: ClientBillingInfo) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/client/billing/info`, data);

        if (!response.ok) {
            alert('Unable to update client info data: ' + result);
        } else {
            setSelectedClient(selectedClient);
        }
    };

    const addTsdiClient = async (payload: Client) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/client`, payload);

        if (response.ok) {
            console.log('successfully added a client ' + result);
        } else {
            console.log('Unable to get client data!');
        }
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            console.log('Got Billing Accounts Data!!!' + result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const incrementClients = () => {
        if (!!fetchNextPage) {
            let newSearchOptions = _.cloneDeep(clientSearchOptions);
            newSearchOptions.incrementPageNumber();
            setClientSearchOptions(newSearchOptions);
        }
    };

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('VouchersPage onCreate()');
        getInvoiceTypes();
        setAddingClient(false);
        getClients();
        getClientTypes();
        getBillingAccounts();
        initializeClientSearchSettings();
        getCurrentMileageRate();
        getBillbyOptions();
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VouchersPage onDestroy()');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const onCancel = () => {
        setAddingClient(false);
        dispatch(actions.layout.hideDialog());
    };

    const hideDialog = () => {
        setAddingClient(false);
        dispatch(actions.layout.hideDialog());
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);

        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);

        if (response.ok) {
            setClientTypes([]);
            setClientTypes(result);
        } else {
            setClientTypes([]);
            console.log('Unable to get client type data!');
        }
    };

    const resetClientSearchOptions = () => {
        setFetchNextPage(true);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        const fieldValues = clientSearchTerm.split(',');
        newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
        setClientSearchOptions(newClientSearchOptions);
    };

    const findClient = (addNewClient: boolean) => {
        if (!!addNewClient) {
            setAddingClient(true);
        } else {
            setAddingClient(false);
            showDialog(DialogList.FIND_CLIENT);
        }
    };

    const displayTitle = () => {
        const title = 'Client Billing Maintenance';

        return title;
    };

    const resetInvoiceTypeValues = (index: number) => {
        let rep = getValues().invoiceTypes;
        let newList = [...rep];

        for (let i = index; i < rep.length - 1; i++) {
            setValue(`invoiceTypes[${i}].id`, rep[i + 1].id);
        }
        setValue(`invoiceTypes[${newList.length - 1}].id`, 0);
        newList.splice(newList.length - 1, 1);

        setSelectedInvoiceTypes(newList);
    };

    const displayClientBillingSettings = () => {
        return (
            <>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Default Day Rate'}
                    labelOnLeft={true}
                    name={'dayRate'}
                    register={register}
                    style={{width: '30%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Mileage Rate:'}
                    labelOnLeft={true}
                    name={'mileageRate'}      
                    register={register}
                    style={{width: '40%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '80%' }}
                />
                <RHFSelect
                    label="Bill By"
                    name="billBy"
                    options={!!billByOptions ? billByOptions : [{ value: 0, label: 'day/prospect' }]}
                    register={register}
                    errors={errors}
                />
                <RHFInputBox
                    label={'Invoices Due:'}
                    labelOnLeft={true}
                    name={'invoiceDueDays'}      
                    register={register}
                    style={{width: '40%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '80%' }}
                />
            </div>
            <div className="form-row" style={{ width: '55vw', marginBottom: '0' }}>
            <RHFLegend
                title="Invoice Types"
            />
                    <div style={{ display: 'flex' }}>
                        <div style={{ marginRight: '1rem', borderRight: '1px solid grey', paddingRight: '.5rem', width: '80%' }}>
                            <InvoiceTypeList
                                typeList={invoiceTypeList}
                                selectedTypeList={selectedInvoiceTypes}
                                getValues={() => getValues()}
                                resetValues={(i: number) => resetInvoiceTypeValues(i)}
                                register={register}
                                errors={errors}
                                control={control}
                            />
                            {/* <FormRow>
                                <RHFInputBox name="invoiceTypeNumber" label="Number" register={register} errors={errors} />
                                <RHFInputBox name="invoiceTypeDescription" label="Invoice Description" register={register} errors={errors} />
                                <RHFInputBox name="invoiceTypeAccount" label="Invoice Account" register={register} errors={errors} />
                            </FormRow>

                            <FormRow style={{ marginTop: '.5rem' }}>
                                <Button text="Add" />
                                <Button text="Delete" />
                                <Button text="Edit" />
                            </FormRow> */}
                        </div>
                        <div>
                            <FormRow>
                                <div style={{padding: '2px', whiteSpace: 'nowrap', border: 'solid 1px'}}><label>Invoice Factor</label></div>
                                <RHFInputBox name="backupOfficeRate" label="Backup Office Rate" register={register} errors={errors} />
                                <RHFInputBox name="backupOfficePercent" label="Backup Office Percent" register={register} errors={errors} />
                            </FormRow>
                            <FormRow style={{ marginTop: '.5rem' }}>
                                <div className="flex-gap">
                                    <RHFCheckbox
                                        name="printPreparedDate"
                                        register={register}
                                        checked={!!clientBillingInfo?.preparedDate ? clientBillingInfo.preparedDate : false }
                                        label={'Print Prepared Date?'}
                                        onClick={() => { clientBillingInfo.preparedDate = !clientBillingInfo.preparedDate; }}
                                    />
                                </div>
                                <div className="flex-gap">
                                    <RHFCheckbox
                                        name="bopNameOnInvoice"
                                        register={register}
                                        label={'BOP Name on Invoice?'}
                                    />
                                </div>
                                <div className="flex-gap">
                                    <RHFCheckbox
                                        name="breakdownOfficeExpenses"
                                        register={register}
                                        label={'Breakdown TSDI Office Expenses?'}
                                    />
                                </div>
                            </FormRow>
                            <FormRow style={{ marginTop: '.5rem' }}>
                                <div className="input-resize">
                                    <RHFInputBox
                                        defaultVal="D"
                                        name="invoiceformat"
                                        label="Invoice Format"
                                        register={register}
                                        style={{width: '50%'}}
                                        bodyStyle={{width: '80%', whiteSpace: 'nowrap'}}
                                        errors={errors}
                                    />
                                </div>
                                <div className="input-resize">
                                    <RHFSelect
                                        label={`Invoice Supplement`}
                                        name={`invoiceSupplement`}
                                        register={register}
                                        bodyStyle={{width: '100%', whiteSpace: 'nowrap'}}
                                        options={[
                                            { value: '0', label: 'None' },
                                            { value: '1', label: 'Unit Summary' },
                                            { value: '2', label: 'Client LM Summary' }
                                        ]}
                                    />
                                </div>
                                <div className="input-resize">
                                    <RHFSelect
                                        label="Invoice Period"
                                        name="invoicePeriod"
                                        options={[
                                            { value: 'Weekly', label: 'Weekly' },
                                            { value: 'semiMonthly', label: 'Semi-Monthly' },
                                            { value: 'monthly', label: 'Monthly' },
                                        ]}
                                        bodyStyle={{width: '100%', paddingLeft: '12rem', whiteSpace: 'nowrap'}}
                                        register={register}
                                        errors={errors}
                                    />
                                </div>
                            </FormRow>
                            <FormRow style={{ marginTop: '.5rem' }}>
                                <div style={{padding: '2px', whiteSpace: 'nowrap', border: 'solid 1px'}}><label>Required Time Sheets</label></div>
                                <RHFCheckbox
                                    name="clientFormRequired"
                                    register={register}
                                    label={`Client's Form`}
                                />
                                <RHFCheckbox
                                    name="dlcFormrequired"
                                    register={register}
                                    label={'DLC Form'}
                                />
                                <RHFCheckbox
                                    name="recapFormRequired"
                                    register={register}
                                    label={'Recap'}
                                />
                            </FormRow>
                        </div>
                    </div>

            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <div className="flex-gap">
                    <RHFCheckbox
                        name="mealreceiptsrequired"
                        register={register}
                        label={'Meal Receipts Required'}
                    />
                </div>
                <div className="flex-gap">
                    <RHFCheckbox
                        name="chargeBackupPersonnel"
                        register={register}
                        checked={chargBackupState}
                        label={'Charge Backup Personnel?'}
                        onClick={() => { setChargeBackupState(!chargBackupState); }}
                    />
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="chargeTsdiOfficeExpenses" ref={register} />
                    <label htmlFor="chargeTsdiOfficeExpenses">Charge TSDI Office Expenses?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="flatDayRate" ref={register} />
                    <label htmlFor="flatDayRate">Flat Day Rate (No Expenses)?</label>
                </div>
                {<div className="flex-gap">
                    <input type="checkbox" name="clientLmEmailonInvoice" ref={register} />
                    <label htmlFor="clientLmEmailonInvoice">Client LM E-mail on Invoice?</label>
                </div>}
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <div className="flex-gap">
                    <input type="checkbox" name="mileageDestinationRequired" ref={register} />
                    <label htmlFor="mileageDestinationRequired">Mileage Destination Required?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="chargeBackupPersonnelAtCost" ref={register} />
                    <label htmlFor="chargeBackupPersonnelAtCost">Charge Backup Personnel at Cost?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="unityEntryRequired" ref={register} />
                    <label htmlFor="unityEntryRequired">SubCode Required?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="clientProspectNoOnTimeSheet" ref={register} />
                    <label htmlFor="clientProspectNoOnTimeSheet">Enter Client Prospect No. on Time Sheet?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="clientProspectNameOnTimeSheet" ref={register} />
                    <label htmlFor="clientProspectNameOnTimeSheet">Enter Client Prospect Name on Time Sheet?</label>
                </div>
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <div style={{width: '100%', borderTop: '1px solid grey'}}>
                    <div className="mrg-top mrg-btm">
                        <label htmlFor="currentInstructions">Billing Instructions</label>
                        <RHFTextArea
                            name="currentInstructions"
                            register={register}
                            errors={errors}
                            style={{border: 'solid black 1px', width: '100%', height: '10rem'}}
                        />
                    </div>
                </div>
            </div>
            </>
        );
    };

/*     const displayClientBillingInfo = () => {
        return (
            <>
                <RHFLegend title="Client Billing" />
                    <div className="flex-space__between mrg-btm">
                        <FormRow className="flex-space__between" style={{whiteSpace: 'nowrap'}}>
                            <div className="input-resize">
                                <RHFInputBox name="dayRate" label="Default Day Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox name="mileageRate" label="Mileage Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox name="backupRate" label="Backup Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox defaultVal="D" name="invoiceformat" label="Invoice Format" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Invoice Period"
                                    name="invoicePeriod"
                                    options={[
                                        { value: 'Weekly', label: 'Weekly' },
                                        { value: 'semiMonthly', label: 'Semi-Monthly' },
                                        { value: 'monthly', label: 'Monthly' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                        </FormRow>
                    </div>
                    <div>
                        <FormRow className="flex-space__between" style={{whiteSpace: 'nowrap'}}>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Invoice Supplement"
                                    name="invoiceSupplement"
                                    options={[
                                        { value: 'None', label: 'None' },
                                        { value: 'Unit Summary', label: 'Unit Summary' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Bill By"
                                    name="billBy"
                                    options={[
                                        { value: 'dayProspect', label: 'Day/Prospect' },
                                        { value: 'weekProspect', label: 'Week/Prospect' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                        </FormRow>
                    </div>
                    <div style={{ borderTop: '1px solid grey', borderBottom: '1px solid grey' }}>
                        <div className="mrg-top mrg-btm">
                            <RHFTextArea label="Billing Instructions" name="currentInstructions" register={register} errors={errors} />
                        </div>
                    </div>
            </>

        );
    };
 */

    const onSaveChanges = () => {
        if (isDirty) {
            const billingFormData = getValues() as ClientBillingInfo;
            const payload = new ClientBillingInfo();
            payload.dayRate = billingFormData.dayRate;
            payload.mileageRate = billingFormData.mileageRate;
            payload.billBy = billingFormData.billBy;
            payload.invoiceDueDays = billingFormData.invoiceDueDays;
            updateClientBillingInfo(payload);
        }
    };

    useEffect(() => {
        if (!!clientBillingInfo) {
            populateClientBillingForm();
        }
    }, [clientBillingInfo]);

    const displayHeading2 = () => {
        const title = 'Client Billing Settings';

        return title;
    };

    const onSubmit = () => {
        alert ('onSubmit not implemented');
    };

    const moveToNextRecord = () => {
        alert ('onSubmit not implemented');
    };

    const moveToPreviousRecord = () => {
        alert ('onSubmit not implemented');
    };

    const moveToLastRecord = () => {
        alert ('onSubmit not implemented');
    };

    const moveToFirstRecord = () => {
        alert ('onSubmit not implemented');
    };

    const populateClientBillingForm = () => {
        const billingForm = {
            dayRate: clientBillingInfo.dayRate,
            mileageRate: clientBillingInfo.mileageRate,
            billBy: clientBillingInfo.billBy,
            invoiceDueDays: clientBillingInfo.invoiceDueDays,
            printPreparedDate: clientBillingInfo.preparedDate,
            backupOfficeRate: clientBillingInfo.backupRate,
            backupOfficePercent: clientBillingInfo.chargeBpPercentage,
            chargeBackupPersonnel: clientBillingInfo.chargeBackup
        };
        setChargeBackupState(clientBillingInfo.chargeBackup);
        reset(billingForm as Partial<ClientBillingInfo>);
    };

    const renderClientBillingToggles = () => {
        return (
         <>
            <div className="form-row" style={{width: '100%', marginBottom: '0' }}>
                <RHFInputBox
                    name="dunsNo"
                    label="DUNS No."
                    register={register}
                    errors={errors}
                />
                <RHFInputBox
                    name="contactName"
                    label="Contact Name"
                    register={register}
                    errors={errors}
                />
                <RHFInputBox
                    name="remitDept"
                    label="Remit Dept."
                    register={register}
                    errors={errors}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    name="contactPhone"
                    label="Contact Phone"
                    register={register}
                    errors={errors}
                />
                <RHFInputBox
                    name="apWebsite"
                    label="A/P Website"
                    register={register}
                    errors={errors}
                />
                <RHFInputBox
                    name="contactEmail"
                    label="Contact Email"
                    register={register}
                    errors={errors}
                />
            </div>
            <div style={{width: '100%', borderTop: '1px solid grey', borderBottom: '1px solid grey' }}>
                <div className="form-row" style={{ marginBottom: '0' }}>
                    <RHFCheckbox
                        name="billToOtherProject"
                        label="Bill To Other Project?"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="arInvoiceGrouping"
                        label="A/R Invoice Grouping?"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="enterClientAFENoOnTimeSheet"
                        label="Enter Client AFE No. on Time Sheet?"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="unitTaskEntryRequired"
                        label="Altsubcode Entry Required?"
                        register={register}
                        errors={errors}
                    />
                </div>
                <div className="form-row" style={{ marginBottom: '0' }}>
                    <RHFCheckbox
                        bodyStyle={{ width: '210px' }}
                        name="doNotExceedProject"
                        label="Do Not Exceed Project?"
                        labelStyle={{whiteSpace: 'nowrap'}}
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="turnkeyBilling"
                        label="Turnkey Billing?"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="enterClientAccountNoOnTimeSheet"
                        label="Enter Client Account No on Time Sheet?"
                        register={register}
                        errors={errors}
                    />
                </div>
                <div className="form-row" style={{ marginBottom: '0' }}>
                    <RHFCheckbox
                        name="roundDays"
                        label="Round Days on Backup/Office"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        bodyStyle={{ width: '340px' }}
                        name="printAFEStatusOnInvoiceCoverLetter"
                        label="Print AFE Status on Invoice/Cover?"
                        register={register}
                        errors={errors}
                    />
                    <RHFInputBox
                        name="totalAfeWarningPercentage"
                        label="Total AFE Warning %"
                        register={register}
                        errors={errors}
                    />
                    <RHFSelect 
                        label="Billing Frequency"
                        name={`billingFrequency`}
                        options={[
                            { value: '0', label: 'Semi-Monthly' },
                            { value: '1', label: 'Monthly' },
                            { value: '0', label: 'Bi-Monthly' },
                            { value: '1', label: 'Quarterly' },
                            { value: '0', label: 'Semi-Annual' },
                            { value: '1', label: 'Annual' },
                        ]}
                        register={register} 
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '25%' }}
                    />
                </div>
            </div>
         </>   
        );
    };

    return (
        <div>
            <CPNavBar/>
            <ClientProjectSearch
                setSelectedClient={setSelectedClient}
                clients={clients}
                size={6}
            />
            <div style={{display: 'flex', width: '100vw', justifyContent: 'center'}}>
                <form id="clientInfoForm" onSubmit={handleSubmit(onSubmit)}>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <div style={{display: 'flex'}}>
                                                <RHFInputBox
                                                    name={'clientNumber'}
                                                    bodyStyle={{width: '30%'}}
                                                    style={{width: '100%'}}
                                                    register={registerSelectedClient}
                                                />
                                                <RHFInputBox
                                                    name={'clientName'}
                                                    bodyStyle={{width: '100%'}}
                                                    style={{width: '100%'}}
                                                    register={registerSelectedClient}
                                                />
                                            </div>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Client"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findClient(false)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Client"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findClient(true)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToFirstRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToPreviousRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Save Changes"
                                                reactIcon={FaRegSave}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => onSaveChanges()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToNextRecord}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastRecord}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Instruction History"
                                                reactIcon={MdHistory}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                        </div>                                    
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>                                        
                                        {displayClientBillingSettings()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel>
                                    <div className="form-row" style={{ marginBottom: '0' }}>
                                        <div style={{ width: '100%' }}>
                                            {renderClientBillingToggles()}
                                        </div>
                                    </div>
                                    <label id="BillingCodeError" style={{display: 'none', color: 'red'}}>Test</label>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
            <FindClientDialog 
                dialogName={DialogList.FIND_CLIENT} 
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                incrementClients={incrementClients}
                addNewClient={addingClient}
                setSelectedClient={setSelectedClient}
                mileageRate={currentMileageRate}
                onAddNewClient={addTsdiClient}
                clientTypes={clientTypes}
            />
        </div>
    );
};

export default ManageClientBilling;


// WEBPACK FOOTER //
// ./src/components/client-project/pages/ManageClientBilling.tsx